import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useUser } from '../../entities'

// import ViewLayout from '../../components/View/ViewLayout.js'
import ViewBid from './view-bid.js'
import NoMatch from '../../pages/nomatch.js'
import Signin from '../../pages/signin.js'

export default function NoAuthView() {
  const [userData] = useUser()
  window.scrollTo(0, 0)
  return (
    <Routes>
      {/* <Route path={`/`} element={<ViewLayout />}> */}
      <Route path={`/bid/:uid`} element={<ViewBid />} />
      {userData.user ? (
        <Route path="*" element={<NoMatch />} />
      ) : (
        <Route path={'*'} element={<Signin />} />
      )}
      {/* </Route> */}
    </Routes>
  )
}
